import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'

import Reducers from './Reducers';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user', 'parking', 'licensing']
}

const persistedReducer = persistReducer(persistConfig, Reducers)

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };